/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
export interface ISettingsAnalyticsPluginMethods extends IPluginMethodMap {
  getSettingsAnalyticsSync(args?: any): any;
}

export class SettingsAnalyticsPlugin implements IAgentPlugin {
  readonly methods: ISettingsAnalyticsPluginMethods;

  constructor() {
    this.methods = {
      getSettingsAnalyticsSync: this.getSettingsAnalyticsSync.bind(this),
    };
  }

  getSettingsAnalyticsSync(args?: any) {
    return {
      // error:SettingsAnalyticsConfig
    };
  }
}
